/**
 * Landing Feature - Mappers
 * Transform between DTOs and Entities
 */

import type { ContactFormRequestDTO, MailingListRequestDTO } from "../dto";
import type {
  ContactFormData,
  MailingListSubscription,
} from "../../domain/entities";

/**
 * Contact form mapper
 */
export const contactFormMapper = {
  /**
   * Map entity to DTO for API call
   */
  toDTO: (data: ContactFormData): ContactFormRequestDTO => ({
    name: data.name,
    email: data.email,
    mobile: data.phone,
    location: data.address,
    subject: data.subject,
    message: data.message,
  }),
};

/**
 * Mailing list mapper
 */
export const mailingListMapper = {
  /**
   * Map entity to DTO for API call
   */
  toDTO: (data: MailingListSubscription): MailingListRequestDTO => ({
    email: data.email,
    captcha_challenge: data.captchaToken,
  }),
};
